"use client";
import React, { lazy } from "react";
import ItemRecentLineup from "./item";
const NoData = lazy(() => import("@/components/client/NoData"));

const DataRecentLineupComponent = ({ lineupData }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 max-w-[816px] mt-5 mb-[24px] m-auto gap-[16px] [&>*]:rounded-[4px]">
      <div className="[&>*]:px-[33px] bg-white dark:bg-dark-slate">
      <div className="home_name rounded-[4px] rounded-bl-none bg-custom-gradient-recent-lineup text-sm pl-[33px] pt-[3px] text-white w-max !pr-[52px]">
          {lineupData.homeTeam.name}
        </div>
        <div className="bg-royal-blue font-bold text-white dark:bg-pure-black py-[6px] text-[10px]">
          Đội hình ({lineupData.homeTeam.formation})
        </div>
        <div className="grid grid-cols-2 gap-x-[20px] gap-y-[10px] py-[8px]">
          {lineupData.homeTeam.lineup.map((player, index) => (
            <ItemRecentLineup
              key={index}
              number={player.number}
              position={player.namePosition}
              name={player.name}
            />
          ))}
        </div>
        <div className="bg-header-blue font-bold text-dark-gray dark:text-stroke-o3 dark:bg-pure-black py-[6px] text-[10px]">
          Dự bị
        </div>
        <div className="grid grid-cols-2 gap-x-[20px] gap-y-[10px] py-[8px]">
          {lineupData.homeTeam.substitutes.map((player, index) => (
            <ItemRecentLineup
              key={index}
              number={player.number}
              position={null}
              name={player.name}
            />
          ))}
        </div>
      </div>

      <div className="[&>*]:px-[33px] [&>*]:ml-auto bg-white dark:bg-dark-slate">
      <div className="home_name ml-auto text-right rounded-[4px] rounded-br-none bg-custom-gradient-recent-lineup-away text-sm pl-[33px] pt-[3px] text-button-blue-bet  w-max pr-[52px]">
          {lineupData.awayTeam.name}
        </div>
        <div className="bg-semi-transparent-golden-yellow dark:bg-pure-black font-bold text-button-blue-bet dark:text-stroke-o3 py-[6px] text-[10px]">
          Đội hình ({lineupData.awayTeam.formation})
        </div>
        <div className="grid grid-cols-2 gap-x-[20px] gap-y-[10px] py-[8px]">
          {lineupData.awayTeam.lineup.map((player, index) => (
            <ItemRecentLineup
              key={index}
              number={player.number}
              position={player.namePosition}
              name={player.name}
              styles={{
                numberClass:
                  "bg-custom-gradient-number-lineup-away text-button-blue-bet",
              }}
            />
          ))}
        </div>
        <div className="bg-header-blue dark:bg-pure-black font-bold text-dark-gray dark:text-stroke-o3 py-[6px] text-[10px]">
          Dự bị
        </div>
        <div className="grid grid-cols-2 gap-x-[20px] gap-y-[10px] py-[8px]">
          {lineupData.awayTeam.substitutes.map((player, index) => (
            <ItemRecentLineup
              key={index}
              number={player.number}
              position={null}
              name={player.name}
              styles={{
                numberClass:
                  "bg-custom-gradient-number-lineup-away text-button-blue-bet",
              }}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

const DataRecentLineup = ({ lineupData, match }) => {
  const homeformation = lineupData?.data?.homeLineUpLastMatch?.lineUps?.[0]?.homeFormation || "";
  const awayformation = lineupData?.data?.awayLineUpLastMatch?.lineUps?.[0]?.awayFormation || "";
  
  const homeLineupData = lineupData?.data?.homeLineUpLastMatch?.lineUps?.[0]?.playerLineUps || [];
  const awayLineupData = lineupData?.data?.awayLineUpLastMatch?.lineUps?.[0]?.playerLineUps || [];
  
  const homeMainPlayers = homeLineupData?.filter((player) => player.type === "home") || [];
  const homeBackupPlayers = homeLineupData?.filter((player) => player.type === "homeBackup") || [];
  
  const awayMainPlayers = awayLineupData?.filter((player) => player.type === "away") || [];
  const awayBackupPlayers = awayLineupData?.filter((player) => player.type === "awayBackup") || [];
  
  const lineupDatax = {
    homeTeam: {
      name: match?.homeTeam?.name || "",
      formation: homeformation,
      lineup: homeMainPlayers,
      substitutes: homeBackupPlayers,
    },
    awayTeam: {
      name: match?.awayTeam?.name || "",
      formation: awayformation,
      lineup: awayMainPlayers,
      substitutes: awayBackupPlayers,
    },
  };
  if(homeLineupData.length == 0 && awayLineupData.length == 0){
    return (
      match.status === "-1" ? 
        <NoData message="Không có dữ liệu"/>
        :
        <NoData message="Đang cập nhật..."/>
    )
  }
  return <DataRecentLineupComponent lineupData={lineupDatax} />;
};

export default React.memo(DataRecentLineup);
